<template>
  <div>
    <el-dialog title="请选择数据源类型" :visible.sync="show" width="86%" append-to-body>
      <div style="text-align:center">
        <el-radio-group v-model="dataSourceType" size="mini" @dblclick.native="next">
          <el-radio-button label="model">模型</el-radio-button>
          <el-radio-button label="dynamicForm">动态表单</el-radio-button>
          <el-radio-button label="apiDataSource">API数据源</el-radio-button>
          <el-radio-button label="api">API接口</el-radio-button>
        </el-radio-group>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="show = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="next">下一步</el-button>
      </div>
    </el-dialog>
    <model-select-dialog @save="onSave" ref="modelSelectDialog" :dataType="dataType" :configColumn="configColumn" :configCondition="configCondition" :configOperation="configOperation" :endpoint="endpoint"></model-select-dialog>
    <form-select-dialog @save="onSave" ref="formSelectDialog" :dataType="dataType" :configColumn="configColumn" :configCondition="configCondition" :configOperation="configOperation" :endpoint="endpoint" :uiId="uiId"></form-select-dialog>
    <api-data-source-select-dialog @save="onSave" ref="apiDataSourceSelectDialog" :dataType="dataType" :configColumn="configColumn" :configCondition="configCondition" :configOperation="configOperation" :endpoint="endpoint"></api-data-source-select-dialog>
    <api-select-dialog @save="onSave" ref="apiSelectDialog" :dataType="dataType" :configColumn="configColumn" :configCondition="configCondition" :configOperation="configOperation" :endpoint="endpoint"></api-select-dialog>
  </div>
</template>

<script>
import ModelSelectDialog from './ModelSelectDialog'
import FormSelectDialog from './FormSelectDialog'
import ApiDataSourceSelectDialog from './ApiDataSourceSelectDialog'
import ApiSelectDialog from './ApiSelectDialog'

export default {
  name: 'data-source-select-dialog',
  components: {
    ModelSelectDialog,
    FormSelectDialog,
    ApiDataSourceSelectDialog,
    ApiSelectDialog
  },
  props: {
    endpoint: { type: String, required: true },
    uiId: { type: Number, required: true },
    dataType: { type: String, required: false },
    configColumn: { type: Boolean, required: false },
    configCondition: { type: Boolean, required: false },
    configOperation: { type: Boolean, required: false }
  },
  data () {
    return {
      show: false,
      dataSourceType: 'model',
      dataSource: {},
      dataSourceValue: undefined
    }
  },
  methods: {
    open (value) {
      if (value) {
        this.dataSource = JSON.parse(value)
        this.dataSourceValue = value
        this.dataSourceType = this.dataSource.type
      } else {
        this.dataSource = {}
        this.dataSourceValue = undefined
        this.dataSourceType = 'model'
      }
      this.show = true
    },
    next () {
      if (this.dataSourceType === 'model') {
        this.$refs.modelSelectDialog.open(this.dataSource.type === 'model' ? this.dataSourceValue : undefined)
      } else if (this.dataSourceType === 'dynamicForm') {
        this.$refs.formSelectDialog.open(this.dataSource.type === 'dynamicForm' ? this.dataSourceValue : undefined)
      } else if (this.dataSourceType === 'apiDataSource') {
        this.$refs.apiDataSourceSelectDialog.open(this.dataSource.type === 'apiDataSource' ? this.dataSourceValue : undefined)
      } else if (this.dataSourceType === 'api') {
        this.$refs.apiSelectDialog.open(this.dataSource.type === 'api' ? this.dataSourceValue : undefined)
      }
    },
    onSave (settings) {
      this.$emit('save', settings)
      this.show = false
    }
  }
}
</script>
